// Tarifs semaine par semaine (source: fichier Excel proprietaire, prolonge apres sept 2027)
// electra=true => consommation electrique en sus (selon releve du compteur, periode hivernale).
const weeklyPrices = [
  {
    "id": "23c94d3a-6179-4a87-ab31-163c84eb76a6",
    "week": 37,
    "start": "2026-09-05",
    "end": "2026-09-12",
    "price": 1450,
    "electra": false
  },
  {
    "id": "8c1dd6e8-4c3a-4e05-951c-0dbb7c6a58aa",
    "week": 38,
    "start": "2026-09-12",
    "end": "2026-09-19",
    "price": 1200,
    "electra": false
  },
  {
    "id": "21d7b3a7-630e-4265-b061-c6e78377fa60",
    "week": 39,
    "start": "2026-09-19",
    "end": "2026-09-26",
    "price": 1200,
    "electra": false
  },
  {
    "id": "2605422a-101d-4ad3-93c5-c5f11896f2eb",
    "week": 40,
    "start": "2026-09-26",
    "end": "2026-10-03",
    "price": 1100,
    "electra": false
  },
  {
    "id": "d868ca31-c9d7-411e-9db8-cb69520fc652",
    "week": 41,
    "start": "2026-10-03",
    "end": "2026-10-10",
    "price": 1100,
    "electra": false
  },
  {
    "id": "3382e3c2-ef57-46c8-a062-9e567e7780fb",
    "week": 42,
    "start": "2026-10-10",
    "end": "2026-10-17",
    "price": 1100,
    "electra": true
  },
  {
    "id": "8a06bf05-ac8d-4826-94ae-c62decf699c0",
    "week": 43,
    "start": "2026-10-17",
    "end": "2026-10-24",
    "price": 1310,
    "electra": true
  },
  {
    "id": "c8f8ced4-19d1-42ff-8b8d-e5671a610e1d",
    "week": 44,
    "start": "2026-10-24",
    "end": "2026-10-31",
    "price": 1310,
    "electra": true
  },
  {
    "id": "bd2c86c2-40d3-4676-80b4-2636f086e10c",
    "week": 45,
    "start": "2026-10-31",
    "end": "2026-11-07",
    "price": 1100,
    "electra": true
  },
  {
    "id": "01ee7ddc-ada8-4727-b0a5-b13864ef14f6",
    "week": 46,
    "start": "2026-11-07",
    "end": "2026-11-14",
    "price": 1100,
    "electra": true
  },
  {
    "id": "795ba0f0-c744-43e3-9547-b2a39fa120a4",
    "week": 47,
    "start": "2026-11-14",
    "end": "2026-11-21",
    "price": 1100,
    "electra": true
  },
  {
    "id": "95731679-9089-4594-9922-e20bd77d790c",
    "week": 48,
    "start": "2026-11-21",
    "end": "2026-11-28",
    "price": 1100,
    "electra": true
  },
  {
    "id": "066b6b90-3e65-46b2-a43e-f568f7b0bd53",
    "week": 49,
    "start": "2026-11-28",
    "end": "2026-12-05",
    "price": 1100,
    "electra": true
  },
  {
    "id": "54e24580-ad64-4ff7-8d1b-ce12e0282118",
    "week": 50,
    "start": "2026-12-05",
    "end": "2026-12-12",
    "price": 1100,
    "electra": true
  },
  {
    "id": "e9c9e898-6cfa-47b8-8094-1c3083fb5c02",
    "week": 51,
    "start": "2026-12-12",
    "end": "2026-12-19",
    "price": 1100,
    "electra": true
  },
  {
    "id": "3d1356f9-6e58-431a-a72e-18a0c7816b82",
    "week": 52,
    "start": "2026-12-19",
    "end": "2026-12-26",
    "price": 1450,
    "electra": true
  },
  {
    "id": "10f06e91-2363-485b-a6f0-3a6decff6fba",
    "week": 1,
    "start": "2026-12-26",
    "end": "2027-01-02",
    "price": 1450,
    "electra": true
  },
  {
    "id": "3f239e5d-886d-4428-871b-20b84b1480f2",
    "week": 2,
    "start": "2027-01-02",
    "end": "2027-01-09",
    "price": 1100,
    "electra": true
  },
  {
    "id": "608feebd-ed6b-4390-ba76-7d576ce69c02",
    "week": 3,
    "start": "2027-01-09",
    "end": "2027-01-16",
    "price": 1100,
    "electra": true
  },
  {
    "id": "df2b2e15-8ae9-4b9b-b6a1-5fe72c8ac36d",
    "week": 4,
    "start": "2027-01-16",
    "end": "2027-01-23",
    "price": 1100,
    "electra": true
  },
  {
    "id": "6bd632b9-bee2-4d0c-a7f4-09639c631250",
    "week": 5,
    "start": "2027-01-23",
    "end": "2027-01-30",
    "price": 1100,
    "electra": true
  },
  {
    "id": "36c8da26-c455-4be4-b50b-1fc78c8381ff",
    "week": 6,
    "start": "2027-01-30",
    "end": "2027-02-06",
    "price": 1100,
    "electra": true
  },
  {
    "id": "e65d2ddc-98db-47dc-a8c7-9f5c2f766d3d",
    "week": 7,
    "start": "2027-02-06",
    "end": "2027-02-13",
    "price": 1200,
    "electra": true
  },
  {
    "id": "3f4892ab-dfd9-40e8-86ef-2cbb09d8939a",
    "week": 8,
    "start": "2027-02-13",
    "end": "2027-02-20",
    "price": 1200,
    "electra": true
  },
  {
    "id": "b8bb3c3d-e946-4697-9c0f-f98b7f6aacf0",
    "week": 9,
    "start": "2027-02-20",
    "end": "2027-02-27",
    "price": 1200,
    "electra": true
  },
  {
    "id": "33b781fc-7d2d-46a9-9f12-25d07d5bc085",
    "week": 10,
    "start": "2027-02-27",
    "end": "2027-03-06",
    "price": 1200,
    "electra": true
  },
  {
    "id": "9665077f-0b93-403d-8edc-ef6a2b61f8d7",
    "week": 11,
    "start": "2027-03-06",
    "end": "2027-03-13",
    "price": 1100,
    "electra": true
  },
  {
    "id": "f177c733-3d79-42b2-a274-988babe53d9b",
    "week": 12,
    "start": "2027-03-13",
    "end": "2027-03-20",
    "price": 1100,
    "electra": true
  },
  {
    "id": "ed81c62c-1819-48c8-ad82-d6008b29fb32",
    "week": 13,
    "start": "2027-03-20",
    "end": "2027-03-27",
    "price": 1100,
    "electra": true
  },
  {
    "id": "3a2319ef-ce0e-4206-ae05-f954fad6ad29",
    "week": 14,
    "start": "2027-03-27",
    "end": "2027-04-03",
    "price": 1100,
    "electra": true
  },
  {
    "id": "38ced8df-0b22-49a8-b293-7e1701b63b21",
    "week": 15,
    "start": "2027-04-03",
    "end": "2027-04-10",
    "price": 1360,
    "electra": true
  },
  {
    "id": "710b0c1e-69ff-404b-90ca-ac5352d8a2a7",
    "week": 16,
    "start": "2027-04-10",
    "end": "2027-04-17",
    "price": 1360,
    "electra": true
  },
  {
    "id": "f9e28be4-9e03-4cc4-a1bb-6b7f3ecb1d20",
    "week": 17,
    "start": "2027-04-17",
    "end": "2027-04-24",
    "price": 1360,
    "electra": true
  },
  {
    "id": "c88422bd-7934-4455-963f-4e32c70278f6",
    "week": 18,
    "start": "2027-04-24",
    "end": "2027-05-01",
    "price": 1460,
    "electra": false
  },
  {
    "id": "422e2919-b51a-4211-86ac-29234ed53f73",
    "week": 19,
    "start": "2027-05-01",
    "end": "2027-05-08",
    "price": 1460,
    "electra": false
  },
  {
    "id": "bde39d39-8eae-4cde-8a98-b9ad2948b617",
    "week": 20,
    "start": "2027-05-08",
    "end": "2027-05-15",
    "price": 1460,
    "electra": false
  },
  {
    "id": "b75afff2-1c4f-4f8c-8019-6b143bf45d24",
    "week": 21,
    "start": "2027-05-15",
    "end": "2027-05-22",
    "price": 1460,
    "electra": false
  },
  {
    "id": "8333af3e-359a-4780-816b-54fceb2c7a32",
    "week": 22,
    "start": "2027-05-22",
    "end": "2027-05-29",
    "price": 1460,
    "electra": false
  },
  {
    "id": "7aecbee0-d451-4940-8c52-8e3ce988fd27",
    "week": 23,
    "start": "2027-05-29",
    "end": "2027-06-05",
    "price": 1460,
    "electra": false
  },
  {
    "id": "d5801837-470d-4c0e-a831-24829ee2d4b8",
    "week": 24,
    "start": "2027-06-05",
    "end": "2027-06-12",
    "price": 1460,
    "electra": false
  },
  {
    "id": "bb2aa747-99a3-40f5-b37d-2ce387d57f88",
    "week": 25,
    "start": "2027-06-12",
    "end": "2027-06-19",
    "price": 1460,
    "electra": false
  },
  {
    "id": "27253f33-263e-4a66-967c-0a0cb7c70f3b",
    "week": 26,
    "start": "2027-06-19",
    "end": "2027-06-26",
    "price": 1460,
    "electra": false
  },
  {
    "id": "9412ed8d-fe6c-4add-9fba-9444100c42b2",
    "week": 27,
    "start": "2027-06-26",
    "end": "2027-07-03",
    "price": 1460,
    "electra": false
  },
  {
    "id": "34c88be3-a81c-4d9d-b595-285c4822ef1f",
    "week": 28,
    "start": "2027-07-03",
    "end": "2027-07-10",
    "price": 1740,
    "electra": false
  },
  {
    "id": "fcf2fd56-d61c-4c76-b8ec-20db564aa030",
    "week": 29,
    "start": "2027-07-10",
    "end": "2027-07-17",
    "price": 1740,
    "electra": false
  },
  {
    "id": "bb649665-24b2-4071-b055-11a91b6578a5",
    "week": 30,
    "start": "2027-07-17",
    "end": "2027-07-24",
    "price": 2510,
    "electra": false
  },
  {
    "id": "0f42de64-3cf6-4ff8-b810-d17384feb5ea",
    "week": 31,
    "start": "2027-07-24",
    "end": "2027-07-31",
    "price": 2710,
    "electra": false
  },
  {
    "id": "4ead741d-3511-44a6-bf5d-f21cb3b91a91",
    "week": 32,
    "start": "2027-07-31",
    "end": "2027-08-07",
    "price": 3360,
    "electra": false
  },
  {
    "id": "bd1bf9b2-a1f4-4d2b-ace1-6fd3ad4acb21",
    "week": 33,
    "start": "2027-08-07",
    "end": "2027-08-14",
    "price": 3360,
    "electra": false
  },
  {
    "id": "da6f65c0-8e72-485c-9990-41e9369b7bfe",
    "week": 34,
    "start": "2027-08-14",
    "end": "2027-08-21",
    "price": 3360,
    "electra": false
  },
  {
    "id": "a7be1fa1-6519-40f7-b4c8-9a567e860f06",
    "week": 35,
    "start": "2027-08-21",
    "end": "2027-08-28",
    "price": 1460,
    "electra": false
  },
  {
    "id": "c57f16ff-66de-47bc-a8af-9784cd33dee1",
    "week": 36,
    "start": "2027-08-28",
    "end": "2027-09-04",
    "price": 1460,
    "electra": false
  },
  {
    "id": "3cb5d39d-962e-495f-b700-fc8d1120e5b6",
    "week": 37,
    "start": "2027-09-04",
    "end": "2027-09-11",
    "price": 1460,
    "electra": false
  },
  {
    "id": "8486b85b-b313-4c6d-bb51-6fe7f49e6d14",
    "week": 38,
    "start": "2027-09-11",
    "end": "2027-09-18",
    "price": 1200,
    "electra": false
  },
  {
    "id": "fd03e648-304c-4365-bdc9-2043283b4e84",
    "week": 39,
    "start": "2027-09-18",
    "end": "2027-09-25",
    "price": 1200,
    "electra": false
  },
  {
    "id": "02c16dea-dfaa-4ed0-a8a4-1a303a952b93",
    "week": 40,
    "start": "2027-09-25",
    "end": "2027-10-02",
    "price": 1100,
    "electra": false
  },
  {
    "id": "3712484f-681b-440e-b547-ae277bce5788",
    "week": 41,
    "start": "2027-10-02",
    "end": "2027-10-09",
    "price": 1100,
    "electra": false
  },
  {
    "id": "3fbe4493-7137-4f58-b01f-a019abb4ade5",
    "week": 42,
    "start": "2027-10-09",
    "end": "2027-10-16",
    "price": 1100,
    "electra": true
  },
  {
    "id": "a70d3163-9dc7-4445-978a-4ba59c5c2402",
    "week": 43,
    "start": "2027-10-16",
    "end": "2027-10-23",
    "price": 1310,
    "electra": true
  },
  {
    "id": "71698bce-5c44-4c16-aeb0-f6064534de4a",
    "week": 44,
    "start": "2027-10-23",
    "end": "2027-10-30",
    "price": 1310,
    "electra": true
  },
  {
    "id": "3888e407-1939-4254-9e8a-7fac7672d9e8",
    "week": 45,
    "start": "2027-10-30",
    "end": "2027-11-06",
    "price": 1100,
    "electra": true
  },
  {
    "id": "b2bd6e0c-1ba6-4197-8f13-de7736bb8bfd",
    "week": 46,
    "start": "2027-11-06",
    "end": "2027-11-13",
    "price": 1100,
    "electra": true
  },
  {
    "id": "42dd9baf-a82c-41ad-a9b8-102aeea1affe",
    "week": 47,
    "start": "2027-11-13",
    "end": "2027-11-20",
    "price": 1100,
    "electra": true
  },
  {
    "id": "9190e911-1238-4cda-8c1f-1808274292a6",
    "week": 48,
    "start": "2027-11-20",
    "end": "2027-11-27",
    "price": 1100,
    "electra": true
  },
  {
    "id": "dca3c474-396e-44a0-bdab-b5b17ff668a6",
    "week": 49,
    "start": "2027-11-27",
    "end": "2027-12-04",
    "price": 1100,
    "electra": true
  },
  {
    "id": "b08db255-4868-4371-9564-01d0828ba3e4",
    "week": 50,
    "start": "2027-12-04",
    "end": "2027-12-11",
    "price": 1100,
    "electra": true
  },
  {
    "id": "5f331cff-d0d7-4e03-adaf-f1890129914d",
    "week": 51,
    "start": "2027-12-11",
    "end": "2027-12-18",
    "price": 1100,
    "electra": true
  },
  {
    "id": "3825138d-0901-4995-bfba-d932ce2c1385",
    "week": 52,
    "start": "2027-12-18",
    "end": "2027-12-25",
    "price": 1450,
    "electra": true
  },
  {
    "id": "91c9d6ef-5790-43f6-a052-5a392e8ccdde",
    "week": 1,
    "start": "2027-12-25",
    "end": "2028-01-01",
    "price": 1450,
    "electra": true
  },
  {
    "id": "73709453-62a6-43ce-83f4-7e73d355dd53",
    "week": 2,
    "start": "2028-01-01",
    "end": "2028-01-08",
    "price": 1100,
    "electra": true
  },
  {
    "id": "d5147416-e77d-4370-84a3-09d5ad6c0f35",
    "week": 3,
    "start": "2028-01-08",
    "end": "2028-01-15",
    "price": 1100,
    "electra": true
  },
  {
    "id": "c14dcd17-b32d-4612-a1b4-fd659c41379e",
    "week": 4,
    "start": "2028-01-15",
    "end": "2028-01-22",
    "price": 1100,
    "electra": true
  },
  {
    "id": "f311b33e-55be-435b-a8df-5e251d4c7f73",
    "week": 5,
    "start": "2028-01-22",
    "end": "2028-01-29",
    "price": 1100,
    "electra": true
  },
  {
    "id": "67d4e2bd-8f8e-4c70-8add-716adc5e27d9",
    "week": 6,
    "start": "2028-01-29",
    "end": "2028-02-05",
    "price": 1100,
    "electra": true
  },
  {
    "id": "3bca46b0-955a-442d-afc8-22a86d02b063",
    "week": 7,
    "start": "2028-02-05",
    "end": "2028-02-12",
    "price": 1200,
    "electra": true
  },
  {
    "id": "dfebf2af-7862-4c77-860f-e83df2370a8e",
    "week": 8,
    "start": "2028-02-12",
    "end": "2028-02-19",
    "price": 1200,
    "electra": true
  },
  {
    "id": "981da060-24e3-4eeb-91ad-51ef98b0b982",
    "week": 9,
    "start": "2028-02-19",
    "end": "2028-02-26",
    "price": 1200,
    "electra": true
  },
  {
    "id": "0bc4e283-edf4-421e-b4ee-f3682189291f",
    "week": 10,
    "start": "2028-02-26",
    "end": "2028-03-04",
    "price": 1200,
    "electra": true
  },
  {
    "id": "8713a6ab-7372-4916-97ff-a8cec1235982",
    "week": 11,
    "start": "2028-03-04",
    "end": "2028-03-11",
    "price": 1100,
    "electra": true
  },
  {
    "id": "9c0059b6-4a37-4330-a1e5-531a091ad861",
    "week": 12,
    "start": "2028-03-11",
    "end": "2028-03-18",
    "price": 1100,
    "electra": true
  },
  {
    "id": "af2df720-ff88-406c-8fec-ee1315cdc735",
    "week": 13,
    "start": "2028-03-18",
    "end": "2028-03-25",
    "price": 1100,
    "electra": true
  },
  {
    "id": "f4f13737-7f53-4129-b4f0-d73b350c06f9",
    "week": 14,
    "start": "2028-03-25",
    "end": "2028-04-01",
    "price": 1100,
    "electra": true
  },
  {
    "id": "17a2f9b7-0bf4-42b7-8fe2-34f7d7dec9f5",
    "week": 15,
    "start": "2028-04-01",
    "end": "2028-04-08",
    "price": 1360,
    "electra": true
  },
  {
    "id": "92fea898-ea0f-4329-b530-78a97914b013",
    "week": 16,
    "start": "2028-04-08",
    "end": "2028-04-15",
    "price": 1360,
    "electra": true
  },
  {
    "id": "df2bb02a-165c-414f-9e12-51e1dca9cabd",
    "week": 17,
    "start": "2028-04-15",
    "end": "2028-04-22",
    "price": 1360,
    "electra": true
  },
  {
    "id": "db9806f5-50e0-42c3-9031-0759062d18d2",
    "week": 18,
    "start": "2028-04-22",
    "end": "2028-04-29",
    "price": 1460,
    "electra": false
  },
  {
    "id": "eef1f8f7-ab35-4ef0-b6ac-67e2f62d133e",
    "week": 19,
    "start": "2028-04-29",
    "end": "2028-05-06",
    "price": 1460,
    "electra": false
  },
  {
    "id": "0cc265f5-abaa-4fc6-9dd0-0f4ddae7cdd7",
    "week": 20,
    "start": "2028-05-06",
    "end": "2028-05-13",
    "price": 1460,
    "electra": false
  },
  {
    "id": "aff2054e-c4df-4463-a3fb-65e7d56544ea",
    "week": 21,
    "start": "2028-05-13",
    "end": "2028-05-20",
    "price": 1460,
    "electra": false
  },
  {
    "id": "5cfa0265-8c02-46b1-b8b0-adb7469a1ada",
    "week": 22,
    "start": "2028-05-20",
    "end": "2028-05-27",
    "price": 1460,
    "electra": false
  },
  {
    "id": "1acea251-c009-4f59-9c73-790bab67b10c",
    "week": 23,
    "start": "2028-05-27",
    "end": "2028-06-03",
    "price": 1460,
    "electra": false
  },
  {
    "id": "4e94d960-dd3b-4d47-b665-a491a666630d",
    "week": 24,
    "start": "2028-06-03",
    "end": "2028-06-10",
    "price": 1460,
    "electra": false
  },
  {
    "id": "c61592e3-8ada-48c9-86c2-31edccf923f0",
    "week": 25,
    "start": "2028-06-10",
    "end": "2028-06-17",
    "price": 1460,
    "electra": false
  },
  {
    "id": "55bc0447-8c7e-4139-984f-57959b2bc439",
    "week": 26,
    "start": "2028-06-17",
    "end": "2028-06-24",
    "price": 1460,
    "electra": false
  },
  {
    "id": "76cff3f4-e546-4584-9356-2c4a46222a3f",
    "week": 27,
    "start": "2028-06-24",
    "end": "2028-07-01",
    "price": 1460,
    "electra": false
  },
  {
    "id": "5780bfed-139e-4d00-9439-f5cd53b9e6e1",
    "week": 28,
    "start": "2028-07-01",
    "end": "2028-07-08",
    "price": 1740,
    "electra": false
  },
  {
    "id": "092c0f5a-ece5-45c5-8dc4-1c8939627ac1",
    "week": 29,
    "start": "2028-07-08",
    "end": "2028-07-15",
    "price": 1740,
    "electra": false
  },
  {
    "id": "420f0946-4580-4d4b-b7b6-dda6b89237d9",
    "week": 30,
    "start": "2028-07-15",
    "end": "2028-07-22",
    "price": 2510,
    "electra": false
  },
  {
    "id": "9908a916-56de-4493-8ea0-61ddd303ed6a",
    "week": 31,
    "start": "2028-07-22",
    "end": "2028-07-29",
    "price": 2710,
    "electra": false
  },
  {
    "id": "3363398e-646e-4a7c-8bca-8e85358e04e0",
    "week": 32,
    "start": "2028-07-29",
    "end": "2028-08-05",
    "price": 3360,
    "electra": false
  },
  {
    "id": "04f30a10-4d75-4a96-aed6-8bc03ae5fcf4",
    "week": 33,
    "start": "2028-08-05",
    "end": "2028-08-12",
    "price": 3360,
    "electra": false
  },
  {
    "id": "2f4751c9-9b4e-40aa-abff-a5d651378865",
    "week": 34,
    "start": "2028-08-12",
    "end": "2028-08-19",
    "price": 3360,
    "electra": false
  },
  {
    "id": "da59b218-fe59-46ab-b0e6-f72d4e415f8e",
    "week": 35,
    "start": "2028-08-19",
    "end": "2028-08-26",
    "price": 1460,
    "electra": false
  },
  {
    "id": "d0d3f220-3366-48e5-b044-3952874fec5e",
    "week": 36,
    "start": "2028-08-26",
    "end": "2028-09-02",
    "price": 1460,
    "electra": false
  },
  {
    "id": "e96272bc-0d55-46af-9294-cd6631a21eef",
    "week": 37,
    "start": "2028-09-02",
    "end": "2028-09-09",
    "price": 1460,
    "electra": false
  }
];

export default weeklyPrices;
